var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing-payouts"},[_c('div',{staticClass:"payout-systems"},_vm._l((_vm.systems),function(system){return _c('div',{key:system.code,staticClass:"payout-system"},[_c('img',{attrs:{"src":system.img}})])}),0),_c('payouts-title'),_c('div',{staticClass:"payouts-text"},[_vm._v(" "+_vm._s(_vm.$t('landing.payouts.text'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }